import { useContext, useState } from "react";
import { Radio } from "antd";
import { PaymentLinkContext } from "../../../context/PaymentLinkContext";
const style = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
};

const options = [
    { value: 1, label: 'Désactivé' },
    { value: 2, label: 'Ordre croissant' },
    { value: 3, label: 'Ordre décroissant' }
];

const SortAmoutPart = ({ setFilteredLinks, showSortModal }) => {

    const { paymentLinks } =useContext(PaymentLinkContext); 

    const [value, setValue] = useState(1);

    const sort = (e) => {
        const sortValue = e.target.value;
        setValue(sortValue);
        if(sortValue == 2) {
            const sortedLinks = [...paymentLinks].sort((a, b) => b.amount - a.amount);
            setFilteredLinks(sortedLinks);
            showSortModal(false);
        } else if(sortValue == 3) {
            const sortedLinks = [...paymentLinks].sort((a, b) => a.amount - b.amount);
            setFilteredLinks(sortedLinks);
            showSortModal(false);
        } else if (sortValue == 1) {
            setFilteredLinks(paymentLinks);
            showSortModal(false);
        }
    };

    return (
        <Radio.Group
            style={style}
            onChange={sort}
            value={value}
        >
            {options.map(option => (
                <Radio key={option.value} value={option.value}>
                    {option.label}
                </Radio>
            ))}
        </Radio.Group>
    )
}

export default SortAmoutPart;